// Livy Market — scripts propios (vanilla, sin librerías externas).

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initHeroParallax() {
  var hero = document.querySelector('.mt-hero__fondo img');
  if (!hero) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress = (vh - rect.top) / (vh + rect.height);
      var offset = Math.max(-18, Math.min(18, (progress - 0.5) * 36));
      hero.style.setProperty('--mt-parallax', offset + 'px');
      ticking = false;
    });
  }, { passive: true });
}

function initPasoHover() {
  var pasos = document.querySelectorAll('.mt-paso__visual');
  pasos.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 6;
      var y = ((e.clientY - r.top) / r.height - 0.5) * -6;
      el.style.transform = 'rotate3d(' + (-y / 6) + ',' + (x / 6) + ',0,' + (Math.abs(x) + Math.abs(y)) / 3 + 'deg)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });
}

function initGaleriaProducto() {
  var mainImg = document.getElementById('mt-galeria-principal-img');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.mt-producto__miniatura'));
  if (!mainImg || !thumbs.length) return;

  var actual = thumbs.findIndex(function (b) { return b.classList.contains('mt-activa'); });
  if (actual < 0) actual = 0;

  function activar(index) {
    actual = index;
    var btn = thumbs[actual];
    mainImg.src = btn.dataset.full;
    thumbs.forEach(function (b) { b.classList.remove('mt-activa'); });
    btn.classList.add('mt-activa');
  }

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var intervalo = null;

  function detener() {
    if (intervalo) { clearInterval(intervalo); intervalo = null; }
  }
  function iniciar() {
    if (reducido || thumbs.length < 2) return;
    detener();
    intervalo = setInterval(function () {
      activar((actual + 1) % thumbs.length);
    }, 5000);
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      activar(i);
      iniciar();
    });
  });

  var galeria = mainImg.closest('.mt-producto__galeria');
  if (galeria) {
    galeria.addEventListener('mouseenter', detener);
    galeria.addEventListener('mouseleave', iniciar);
  }

  iniciar();
}

function initVariantesProducto() {
  var form = document.getElementById('mt-producto-form');
  if (!form) return;
  var variantesEl = document.getElementById('mt-variantes-json');
  var opcionesWrap = document.getElementById('mt-opciones');
  var variantIdInput = document.getElementById('mt-variant-id');
  var addBtn = document.getElementById('mt-add-btn');
  var addBtnTexto = document.getElementById('mt-add-btn-texto');
  var precioActual = document.querySelector('.mt-producto__precio-actual');
  var precioAntes = document.querySelector('.mt-producto__precio-antes');
  if (!variantesEl || !opcionesWrap) return;

  var variantes = JSON.parse(variantesEl.textContent);

  function moneyFormat(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function seleccionActual() {
    var valores = [];
    opcionesWrap.querySelectorAll('.mt-producto__valores').forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-producto__valor.mt-activa');
      valores.push(activo ? activo.dataset.value : null);
    });
    return valores;
  }

  function encontrarVariante(valores) {
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
  }

  function actualizar() {
    var valores = seleccionActual();
    var variante = encontrarVariante(valores);
    if (!variante) return;
    variantIdInput.value = variante.id;
    if (precioActual) precioActual.textContent = moneyFormat(variante.price);
    if (precioAntes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntes.textContent = moneyFormat(variante.compare_at_price);
        precioAntes.style.display = '';
      } else {
        precioAntes.style.display = 'none';
      }
    }
    if (variante.available) {
      addBtn.disabled = false;
      addBtnTexto.textContent = addBtn.dataset.textoDisponible || addBtnTexto.textContent;
    } else {
      addBtn.disabled = true;
      if (addBtn.dataset.textoAgotado) addBtnTexto.textContent = addBtn.dataset.textoAgotado;
    }
  }

  opcionesWrap.querySelectorAll('.mt-producto__valor').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grupo = btn.closest('.mt-producto__valores');
      grupo.querySelectorAll('.mt-producto__valor').forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
      actualizar();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initHeroParallax();
  initPasoHover();
  initGaleriaProducto();
  initVariantesProducto();
});
